import React, { useEffect, useState } from "react";

export const StatsPage = () => {
  const [stats, setStats] = useState({ home: 0, summary: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      try {
        const response = await fetch("/api/stats");
        if (!response.ok) {
          throw new Error("Stats fetch failed");
        }
        const data = await response.json();
        if (isMounted) {
          setStats({
            home: Number(data.home || 0),
            summary: Number(data.summary || 0),
          });
        }
      } catch (err) {
        if (isMounted) setError("Impossible de charger les statistiques.");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    load();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="container mx-auto max-w-3xl p-6 brand-shell text-gray-800 mt-6">
      <h1 className="text-2xl font-bold mb-4">Statistiques</h1>
      {loading && <p className="text-gray-500">Chargement…</p>}
      {!loading && error && <p className="text-red-600">{error}</p>}
      {!loading && !error && (
        <div className="space-y-3">
          <div className="flex items-center justify-between border rounded-lg p-4 bg-white">
            <span className="text-sm text-gray-600">Page principale (visites)</span>
            <span className="text-xl font-semibold">{stats.home}</span>
          </div>
          <div className="flex items-center justify-between border rounded-lg p-4 bg-white">
            <span className="text-sm text-gray-600">Résultat final (visites)</span>
            <span className="text-xl font-semibold">{stats.summary}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatsPage;
